import { AxiosError } from 'axios';
import useSWRImmutable from 'swr/immutable';

import { ContractT, WithStatusT } from '@consumer-frontend/nc-utils';

import { apiEndpoints, FIVE_MINUTES_IN_MS } from '../lib';

export type UseContractPropsT = {
  accountId: string;
  loanNumber?: string;
};

export const useContract = ({ accountId, loanNumber }: UseContractPropsT) => {
  const {
    data: contract,
    error,
    isLoading,
  } = useSWRImmutable<WithStatusT<ContractT>, AxiosError>(
    () => (accountId && loanNumber ? apiEndpoints.dashboard.contract(accountId, loanNumber) : null),
    { dedupingInterval: FIVE_MINUTES_IN_MS }, // Don't re-fetch for 5 minutes
  );

  return {
    contract,
    error,
    isLoading,
    status: contract?.status || error?.status,
  };
};
